import { toast } from 'react-toastify';
import { NOTIFICATION_TYPES, NOTIFICATION_MESSAGES, NotificationType, NotificationMessage, NOTIFICATION_TITLES } from '../constants/notifications';
import { TimeSpan } from '@/utility/time-span';

class NotificationManager {
	static dismissAllToasts() {
		toast.dismiss();
	}

	static showMessage(type: NotificationType, message: NotificationMessage | string, options?: any) {
		toast[type](message, options);
	}

	static notifyAIToolResponse(message: string, options: any) {
		this.showMessage(NOTIFICATION_TYPES.INFO, message, options);
	}

	static notifyUnavailable() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.UNAVAILABLE);
	}

	static notifyFeedbackDelay() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.FEEDBACK_DELAY);
	}

	static notifyNoConversations() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.NO_CONVERSATIONS);
	}

	static notifyOpiResponding() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.OPI_RESPONDING);
	}

	static notifyLegalTextAvailable() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.LEGAL_TEXT_AVAILABLE);
	}

	static notifyMessageDelay() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.MESSAGE_DELAY);
	}

	static notifyMessageNoUseMobile() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.NO_USE_MOBILE_DEVICE, {
			autoClose: TimeSpan.minutes.one,
			position: 'top-center'
		});
	}

	static notifyGettingNewOpiTabuCards() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.GETTING_NEW_OPI_TABU_CARDS, {
			autoClose: false
		});
	}

	static notifyDailyUsageError() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.TOOL_DAILY_USAGE_ERROR);
	}

	static notifyRefreshTokenError() {
		this.showMessage(NOTIFICATION_TYPES.INFO, NOTIFICATION_MESSAGES.REFRESH_TOKEN_ERROR);
	}

	static notifySaveSlotChanges() {
		this.showMessage(NOTIFICATION_TYPES.SUCCESS, NOTIFICATION_MESSAGES.SAVE_SLOT_CHANGES, {
			autoClose: TimeSpan.seconds.ten
		});
	}

	static notifySaveSlotChangesError(message: string) {
		this.showMessage(NOTIFICATION_TYPES.ERROR, message || NOTIFICATION_MESSAGES.SAVE_SLOT_CHANGES_ERROR, {
			autoClose: TimeSpan.seconds.five
		});
	}

	static notifyPasswordSuccessfullyReset() {
		this.showMessage(NOTIFICATION_TYPES.SUCCESS, NOTIFICATION_MESSAGES.PASSWORD_SUCCESSFULLY_RESET, {
			autoClose: TimeSpan.seconds.five
		});
	}

	static notifySolverQuestionReportSuccess() {
		toast.success(
			<>
				<div
					style={{
						fontWeight: 'bold',
						marginBottom: '5px',
						display: 'flex',
						alignItems: 'center',
						gap: '8px'
					}}>
					<i className="icons-check-circle" />
					{NOTIFICATION_TITLES.SOLVER_QUESTION_REPORT_SUCCESS}
				</div>
				<div>{NOTIFICATION_MESSAGES.SOLVER_QUESTION_REPORT_SUCCESS}</div>
			</>,
			{
				autoClose: TimeSpan.seconds.three,
				className: 'red-background-toast',
				style: { backgroundColor: '#1D7A68' },
				bodyStyle: { alignItems: 'flex-start' },
				icon: false
			}
		);
	}

	static notifySolverQuestionRejected() {
		toast.warn(
			<>
				<div
					style={{
						fontWeight: 'bold',
						marginBottom: '5px',
						display: 'flex',
						alignItems: 'center',
						gap: '8px'
					}}>
					<i className="icons-close-circle" />
					{NOTIFICATION_TITLES.SOLVER_QUESTION_REJECTED}
				</div>
				<div>{NOTIFICATION_MESSAGES.SOLVER_QUESTION_REJECTED}</div>
			</>,
			{
				autoClose: TimeSpan.seconds.three,
				className: 'red-background-toast',
				style: { backgroundColor: 'var(--danger-fill)' },
				bodyStyle: { alignItems: 'flex-start' },
				icon: false
			}
		);
	}
}

export default NotificationManager;
